import mergeObjects from '@bybeam/platform-lib/answers/mergeObjects';
import { ApplicationAnswers, ApplicationContentInput } from '@bybeam/platform-types';

export default function mergeUpdates(
  updates: Partial<ApplicationContentInput>[],
): ApplicationContentInput {
  const answers: Partial<ApplicationAnswers> = mergeObjects(
    updates.map(({ answers: updateAnswers }) => updateAnswers ?? {}),
    'overwrite',
  );

  return {
    addresses: [],
    documents: [],
    ...mergeObjects(
      updates.map(({ answers: _, ...rest }) => rest),
      'concat',
    ),
    answers,
  };
}
